import React from 'react'
import { Row } from 'antd'
import moment from 'moment'
import { useTranslation } from 'next-i18next'
import { CustomCol, FormLabels, CustomDatePicker } from 'src/components'

const SaleOfferExpirationDate: React.FC = () => {
  const { t } = useTranslation()

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('SalesOffer.ExpirationDate')}
        subtitle={t('SalesOffer.ExpirationDateLabel')}
      />
    </CustomCol>
    <CustomCol>
      <CustomDatePicker
        name='expiration_date'
        placeholder={t('admin.CertificateDatePlaceholder')}
        otherRules={[
          () => ({
            validator(_, date_end: moment.Moment) {
              const currentDate = moment()
              if (!date_end) { return Promise.resolve() }
              if (date_end.isSameOrAfter(currentDate)) { return Promise.resolve() }
              return Promise.reject(new Error(t('SalesOffer.DateError')))
            },
          })
        ]}
      />
    </CustomCol>
  </Row>
}

export default SaleOfferExpirationDate
